<template>
    <!-- eslint-disable max-len -->
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        :class="[
            'svg--timer',
            { 'svg--timer--mini': !loadLargeCounter }
        ]"
        width="288"
        height="288"
        viewBox="0 0 288 288"
        role="img"
        :aria-label="$t('accessibility.timer')"
    >
        <defs>
            <filter id="filterOne" x="0" y="0" width="288" height="288" filterUnits="userSpaceOnUse">
                <feOffset dy="1" input="SourceAlpha"/>
                <feGaussianBlur stdDeviation="3" result="b"/>
                <feFlood flood-opacity="0.161"/>
                <feComposite operator="in" in2="b"/>
                <feComposite in="SourceGraphic"/>
            </filter>
            <filter id="filterTwo" x="21" y="21" width="246" height="246" filterUnits="userSpaceOnUse">
                <feOffset dy="1" input="SourceAlpha"/>
                <feGaussianBlur stdDeviation="3" result="d"/>
                <feFlood flood-opacity="0.161"/>
                <feComposite operator="in" in2="d"/>
                <feComposite in="SourceGraphic"/>
            </filter>
            <filter id="filterThree" x="34" y="35" width="218" height="216" filterUnits="userSpaceOnUse">
                <feOffset input="SourceAlpha"/>
                <feGaussianBlur stdDeviation="3" result="f"/>
                <feFlood flood-opacity="0.161"/>
                <feComposite operator="in" in2="f"/>
                <feComposite in="SourceGraphic"/>
            </filter>
        </defs>
        <g transform="translate(-816 -363)">
            <template v-if="loadLargeCounter">
            <g class="h" transform="matrix(1, 0, 0, 1, 816, 363)" filter="url(#filterOne)">
                <g class="svg--timer__group" transform="translate(9 8)">
                    <circle class="d" cx="135" cy="135" r="135" stroke="none"/>
                    <circle class="e" cx="135" cy="135" r="133.5" fill="none"/>
                </g>
            </g>
            <g class="g" transform="matrix(1, 0, 0, 1, 816, 363)" filter="url(#filterTwo)">
                <g class="svg--timer__group" transform="translate(30 29)">
                    <circle class="d" cx="114" cy="114" r="114" stroke="none"/>
                    <circle class="e" cx="114" cy="114" r="112.5" fill="none"/>
                </g>
            </g>
            <g class="f" transform="matrix(1, 0, 0, 1, 816, 363)" filter="url(#filterThree)" >
                <ellipse class="svg--timer__ellipse" cx="100" cy="99" rx="100" ry="99" transform="translate(43 44)"/>
            </g>
            </template>
            <g
                :class="[
                    'svg--timer__group--border',
                    `svg--timer__group--border--${color}`,
                    loadLargeCounter ? 'svg--timer__group--border--default' : 'svg--timer__group--border--mini'
                ]"
                transform="translate(830 376)"
                fill="none"
            >
                <circle class="d" cx="130" cy="130" r="130" stroke="none"/>
                <circle ref="elementCircle" id="timerCircle" class="svg--timer__group--border__circle" cx="130" cy="130" r="123" stroke-dasharray="780"/>
            </g>
        </g>
    </svg>
</template>

<script>
// package
import { ref, onMounted } from '@vue/composition-api';

export default {
    props: {
        duration: {
            type: Number,
            default: 60 // 60 segundos
        },
        loadLargeCounter: {
            type: Boolean,
            default: true
        },
        color: String
    },
    setup ( props ) {
        const elementCircle = ref( null );

        onMounted( () => {
            // É necessário o timer, devido a animação
            // inicial do timer ( svg ) que dura 1s.
            setTimeout( () => {
                elementCircle.value.style.animationDuration = `${props.duration}s`;
                elementCircle.value.classList.add( 'js--active' );
            }, 1500 );
        });

        return { elementCircle };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Animations
    // =============================================================================
    @include keyframes ( initial-fill ) {
        0%   { stroke-dashoffset: 780; }
        100% { stroke-dashoffset: 0; }
    }

    @include keyframes ( fill ) {
        0%   { stroke-dashoffset: 0; }
        100% { stroke-dashoffset: 780; }
    }

    // =============================================================================
    // Style
    // =============================================================================
    .svg {
        &--timer {
            @include transform( rotate( 90deg ) scaleX( - 1 ) );
            &--mini {
                @include rounded-corner( 50% );
                @include box-shadow( 0 1px 10px $color-black-light );
            }
            &__group {
                fill: $bg-color;
                stroke: $color-white;
                stroke-width: 3px;
                &--border {
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    @include transition( stroke .3s ease-in-out );
                    will-change: stroke;
                    &--default {
                        stroke-width: 14px;
                    }
                    &--mini {
                        stroke-width: 30px;
                    }
                    &--green {
                        stroke: $color-green;
                    }
                    &--grey {
                        stroke: $color-grey;
                    }
                    &--red {
                        stroke: $color-red;
                    }
                    &__circle {
                        transform-origin: center;
                        animation-name: initial-fill;
                        animation-duration: .6s;
                        animation-iteration-count: 1;
                        stroke-dashoffset: 0;
                        &.js--active {
                            animation-name: fill;
                            animation-play-state: running;
                            animation-timing-function: linear;
                        }
                    }
                }
            }
            &__ellipse {
                fill: $color-white;
            }
        }
    }
</style>